const users = (state = {}, action) => {
	switch (action.type) {
		case 'USERS_LIST':
		case 'SET_USER_DETAILS':
		case 'SET_ROLES_LIST':
		case 'RESET_PASSWORD':
		case 'SET_COMPANY_LIST':
		case 'SET_CREATE_USER':
		case 'SET_MODIFY_USER':
		case 'SET_SEARCH_CRITERIA':
		case 'SET_GENERATE_REPORT':
		case 'SET_AUTH_EVENTS':
		case 'SET_SEARCH_ATTRIBUTE':
			return { ...state, ...action.data };
		default:
			return state;
	}
};
export default users;
